import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";

export const ContentContainer = styled(ContentContainerBase)`
  padding-bottom: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    padding-bottom: 40px;
  }
`;

export const TicketImg = styled.img`
  float: left;
  width: 100px;
  height: 100px;
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 140px;
    height: 140px;
  }
`;

export const TicketWrapper = styled.div`
  width: 90%;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  gap: 10px;
  -webkit-appearance: none;
`;

export const Ticket = styled.div`
  width: 330px;
  height: 100px;
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 150px;
  }
`;

export const TicketTextWrapper = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 15px;
  }
`;

export const TicketText = styled.div`
  padding-left: 3px;
  flex-direction: column;
  display: flex;
  gap: 3px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 10px;
  }
`;

export const TicketListWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
  overflow: scroll;
  align-items: center;
  @media ${({ theme }) => theme.device.tablet} {
  }
`;
